import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, SharedModule]
})
export class PrivacyPolicyComponent implements OnInit {

  buttonSelected: string = "PrivacyPolicy";


  constructor() { }

  ngOnInit(): void {
  }

}
